/**
 * Remembers which error objects have already been dealt with by the API error
 * path, so one failure is never recorded twice.
 *
 * The axios interceptor (User.jsx → showApiError) reports a failed request and
 * then re-throws it so the caller can react. A caller that never attaches a
 * `.catch` hands that same error to the window `unhandledrejection` handler in
 * errorReporter.js, which used to report it a second time as
 * "unhandled_rejection" — Monitoring groups #1308/#1218 (500) and #1216 (422).
 * showApiError marks the error; the global handler skips anything marked.
 *
 * Kept out of errorReporter.js on purpose: tests mock that module wholesale,
 * and the mark must keep working when they do.
 *
 * The mark is a non-enumerable property so it never leaks into a serialised
 * error, a React Query cache entry or a test's toEqual().
 */
const MARK = "__rcReported";

export function markErrorReported(error) {
  if (!error || (typeof error !== "object" && typeof error !== "function")) {
    return;
  }
  try {
    Object.defineProperty(error, MARK, {
      value: true,
      enumerable: false,
      configurable: true,
    });
  } catch (_) {
    // A frozen error cannot be marked; worst case it is reported twice.
  }
}

export function wasErrorReported(error) {
  return Boolean(error && error[MARK]);
}
